import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, timer, Subscription } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { Referto } from '../models/referto';
import { MainService } from '../services/main.service';

/**
 * Data source for the AccettazioniList view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class RefertiListDataSource extends DataSource<Referto> {

  paginator: MatPaginator;
  sort: MatSort;
  refertiSubject = new BehaviorSubject<Referto[]>([]);
  loadingSubject = new BehaviorSubject<boolean>(false);

  constructor(private configService: ConfigService, private mainService: MainService) {
    super();
  }

  connect(): Observable<Referto[]> {
    this.refertiSubject.next(this.mainService.getReferti());
    this.loadingSubject.next(false);
    return this.refertiSubject.asObservable();
  }

  disconnect() {
    this.refertiSubject.complete();
    this.loadingSubject.complete();
  }

  getLength(): number {
    return this.refertiSubject.value != null ? this.refertiSubject.value.length : 200;
  }


  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: Referto[]) {
    return data;
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: Referto[]) {
    return data;
  }




}

